import {TokenName} from './lexical.mjs';

class Whitespace {
    consume(tokenIterator) {
        if ([TokenName.LINE_FEED, TokenName.SPACE].includes(tokenIterator.token().name)) {
            tokenIterator.eatTokens(1);
        }
    }
}

export {Whitespace};
